module.exports = __webpack_public_path__ + "img/user-avatar.6f1f03ff.png";